import styled from "styled-components";
import { colors, grid_breakpoints } from "../../../../../theme/theme";

export const OrderListWrapper = styled.div`
	display: flex;
	flex-direction: column;
	padding: 0 40px 24px 17px;
`;
export const OrderListHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 24px;
	margin-bottom: 24px;

	h1 {
		font-size: 28px;
		color: ${colors.greyscale.darker_grey};
		font-weight: bold;
		margin: 0;
	}

	button {
		line-height: 1;
		padding: 8px 16px;
	}
`;
export const OrderListFilters = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 24px;

	@media (max-width: ${grid_breakpoints.md}) {
		flex-direction: column;
		margin-bottom: 16px;
		gap: 8px;
	}
`;
export const OrderListBody = styled.div`
	display: flex;
	justify-content: center;
	margin-bottom: 24px;

	/* a altura dos elementos acima da lista */
	min-height: calc(100svh - 70px - 280px);

	.p-datatable {
		position: relative;
		width: 100%;
		line-height: 1;
	}

	/* caso precise dos headers fixos na tabela
     .p-datatable > .p-datatable-wrapper {
	  	max-height: calc(100svh - 70px - 240px);
	  	overflow-y: auto;
	  }
       .p-datatable-thead {
       	position: sticky;
       	top: 70px;
      	z-index: 1;
      	box-shadow: 0 1px 0 0 ${colors.greyscale.grey};
      }
      */

	.p-datatable
		> .p-datatable-wrapper
		> .p-datatable-table
		> .p-datatable-thead,
	.p-datatable .p-datatable-thead > tr > th {
		background: ${colors.greyscale.white};
	}

	.p-datatable .p-datatable-tbody > tr.p-highlight {
		color: ${colors.greyscale.darker_grey};
		font-weight: bold;
		background: ${colors.mainColors.white_lilac};
	}
`;

export const OrderBatchActions = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;

	.p-dropdown-label {
		line-height: 1;
		padding: 8px 16px;
	}
`;

export const OrderSearchFilter = styled.div`
	--button-width: 52px;
	--clear-button-width: 32px;

	position: relative;
	display: flex;
	align-items: center;
	max-width: 560px;
	flex-grow: 1;

	justify-content: center;
	height: 32px;

	input {
		border: 1px solid ${colors.greyscale.grey};
		border-radius: 4px;
		line-height: 1;
		background: transparent;
		padding: 8px
			calc(16px + var(--clear-button-width) + var(--button-width)) 8px
			16px;
		color: ${colors.greyscale.black};
		font-size: 14px;
		width: 100%;

		&:focus,
		&:active {
			outline: 2px solid ${colors.mainColors.blueberry};
			border-color: transparent;
		}
	}

	input::placeholder {
		font-size: 14;
		color: ${colors.greyscale.grey};
	}

	button {
		position: absolute;
		right: 2px;
		height: 100%;

		border: 0;
		background-color: transparent;

		display: flex;
		align-items: center;
		justify-content: center;

		color: ${colors.greyscale.dark_grey};
		transition: 200ms ease;

		&:hover {
			background: ${colors.greyscale.light_grey};
		}
	}
`;

export const SearchButton = styled.button`
	width: var(--button-width);
	border-radius: 0 4px 4px 0;
	border-left: 1px solid ${colors.greyscale.grey} !important;
`;

export const ClearButton = styled.button`
	width: var(--clear-button-width);
	right: calc(var(--button-width) + 2px) !important;

	svg {
		color: ${colors.greyscale.black};
	}
`;
